import React from "react";
import "./../../assets/sass/pages/home.scss";

import TopBar from "../Header/topbar";
import Footer from "../Footer";
import TopNavbar from "../Header/navbar";

const LayoutOne = ({children }) => {
    return (
      <div>
         <TopBar></TopBar>
            <div className="main_body">
                <TopNavbar></TopNavbar>
                {children }
            </div>
          <Footer />
      </div>
    );
}

const LayoutTwo = ({children }) => {
    return (
      <div>
          {children }
          <Footer />
      </div>
    );
}

const LayoutThree = ({children }) => {
  return (
    <div>
        <TopBar></TopBar>
        {children }
        <Footer />
    </div>
  );
}



export { LayoutOne, LayoutTwo, LayoutThree};
